"use strict";

import angular from "angular";


angular.module("nucont.accounting.company.demonstrations").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.demonstrations.accounting.dre", {
            url: "/DRE?date&view&scenarioId&startDate",
            views: {
                "demonstrationAccountingView@nucont.accounting.company.demonstrations.accounting": {
                    component: "accountingDreComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                demonstration: { value: "DRE", dynamic: false },
                date: { value: null, dynamic: true },
                startDate: { value: null, dynamic: true },
                view: { value: "mensal", dynamic: true },
                scenarioId: { value: null, dynamic: true },
                stateIndentifier: { value: "dre" }
            },
            bodyClass: "dre-module"
        })
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "CompanyData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.comparation",
            {
                url:
                    "/comparacao?month&comparationView&comparationDate&analysisHorizontal&analysisVertical&scenarioIdComparation",
                views: {
                    "demonstrationAccountingView@nucont.accounting.company.demonstrations.accounting": {
                        component: "accountingDreComparationComponent",
                        bindings: { companyData: "CompanyData" }
                    }
                },
                params: {
                    comparationView: { value: null, dynamic: true },
                    comparationDate: { value: null, dynamic: true },
                    analysisHorizontal: { value: null, dynamic: true },
                    analysisVertical: { value: null, dynamic: true },
                    month: { value: null, dynamic: true },
                    stateIndentifier: { value: "dre.comparation" },
                    scenarioIdComparation: { value: null, dynamic: true }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.comparation.showtime",
            {
                url: "/showtime",
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.comparation.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre.comparation": {
                        component: "indicatorDescriptionComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.comparation.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre.comparation": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "CompanyData" }
                    }
                },
                bodyClass: "dre-module"
            }
        )
        .state(
            "nucont.accounting.company.demonstrations.accounting.dre.comparation.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.company.demonstrations.accounting.dre.comparation": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "dre-module"
            }
        );
}
